import { Space, Title, Stack } from "@mantine/core"
import { IconBellOff, IconNotificationOff } from "@tabler/icons-react"

export const NoNotifications = () => {
    return (
        <Stack justify="center" align="center">
            <Space h={150} />
            <IconBellOff size={48} color={'grey'} />
            <Title c="dimmed" fw='normal' order={4}>No Notifications</Title>
        </Stack>
    )
}